import {Option} from "ts-option";
import * as moment from "moment";

/**
 * Main data of individual contact.
 */
export default class IndividualContactMainData {

	/**
	 * String using to search a contact.
	 */
	public readonly searchString: string;

	/**
	 * @param title Title (mr, mrs, sir etc.) of contact.
	 * @param firstName First name of contact.
	 * @param lastName Last name of contact.
	 * @param dateOfBirth Date of birth.
	 */
	constructor(public readonly title: Option<string>,
		public readonly firstName: string,
		public readonly lastName: string,
		public readonly dateOfBirth: Option<moment.Moment>) {
		this.searchString = `${firstName} ${lastName}`.toLowerCase()
	}

	copy({title = this.title, firstName = this.firstName, lastName = this.lastName, dateOfBirth = this.dateOfBirth}): IndividualContactMainData {
		return new IndividualContactMainData(title, firstName, lastName, dateOfBirth);
	}
}